import { FilterOptions } from '@app/layout/filter/interfaces/filter-options';
import { ContentTypeFilterValues } from './content-type-filter-values';

export const contenTypeFilterOptions: FilterOptions<ContentTypeFilterValues> =
  new Map([
    [
      ContentTypeFilterValues.MEDIUM,
      ContentTypeFilterValues.MEDIUM.toUpperCase(),
    ],
    [
      ContentTypeFilterValues.LARGE,
      ContentTypeFilterValues.LARGE.toUpperCase(),
    ],
    [
      ContentTypeFilterValues.ULTRA,
      ContentTypeFilterValues.ULTRA.toUpperCase(),
    ],
  ]);
